import React from "react";
import { Button, Modal } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import CustomButton from "../../../../components/common/CustomButton";
import toastFile from "../../../../Service/ToastFile";
import { useSelector } from "react-redux";
import {
  AddMainCensusFromImportCensus,
  DeleteClientLargeClaimUWByClientId,
  DeletePlanDeviationByClientId,
  DownloadCensusErrorFile,
  ImportCensusFile,
  GetCensusDataByClientIdwithPagging
} from "../../../../api/User/ACG/ImportCensusApi";
import { Link } from "react-router-dom";
import theme from "../../../../Utils/theme";
import {
  CheckClientInCensusByClientId,
  UpdateCensus,
  UpdateCensusStage2,
  UpdateCensusStage3,
  UpdateCensusStage4,
  UpdateCensusStage5,
  UpdateCensusStage6,
} from "../../../../api/User/ACG/planavdeviationApi";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import moment from "moment";

const ImportCensus = () => {
  const user = useSelector((state) => state.userDetails.value);
  const client = useSelector((state) => state.clientData.value);
  const [isProgress, setIsProgress] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingTable, setIsLoadingTable] = useState(false);
  const [importedFile, setImportedFile] = useState(null);
  const [witchAction, setWitchAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(false);
  const [showCarrierDeleteModel, setShowCarrierDeleteModel] = useState({
    isModel: false,
    file: "",
  });
  const [partialModal, setPartialModal] = useState({
    isModal: false,
    file: "",
  });
  const [isLink, setIsLink] = useState(false);
  const [errorFile, setErrorFile] = useState(null);
  const [showTable, setShowTable] = useState(true)
  const [message, setMessage] = useState({ isModal: false, file: "" });
  const [loadingSatge, setLoadingStage] = useState({
    stage1: true,
    stage1IsLoading: false,
    stage2: false,
    stage2IsLoading: false,
    stage3: false,
    stage3IsLoading: false,
    stage4: false,
    stage4IsLoading: false,
    stage5: false,
    stage5IsLoading: false,
    stage6: false,
    stage6IsLoading: false,
  });
  const fileInputRef = useRef(null);

  useEffect(() => {
    const importedFileName = importedFile?.name;
    const importedFileFormat = importedFileName?.substring(
      importedFileName.lastIndexOf(".") + 1
    );

    if (importedFile) {
      setWitchAction("Importing");
      setIsProgress(true);
      setIsLoading(true);
      if (importedFileFormat !== "csv") {
        toastFile("invalid file");
        setImportedFile(null);
        return;
      }

      const formData = new FormData();
      formData.append("files", importedFile);
      setLoadingStage((prev) => ({
        ...prev,
        stage1: true,
        stage1IsLoading: true,
      }));
      let client_name = client?.clientName.replaceAll("&", "%26").replaceAll("#", "%23");
      ImportCensusFile(
        client?.clientID,
        client_name,
        0,
        user?.UD_emp_name,
        formData,
        user.UD_id
      )
        .then(async (res) => {
          if (res.data.success) {
            if (res.data.isCarrier) {
              AddMainCensus(res.data.file);
            } else {
              setShowCarrierDeleteModel({
                isModel: true,
                file: res.data.file,
              });
            }
          } else {
            switch (res.data.message) {
              case "Client Name Not Match":
                setIsProgress(false);
                toastFile(res.data.message);
                break;

              case "Input string was not in a correct format.":
                setIsProgress(false);
                toastFile(res.data.message);
                break;

              case "failed":
                setIsProgress(false);
                setMessage((prev) => ({
                  isModal: true,
                  file: res.data.file,
                }));
                break;

              default:
                setLoadingStage((prev) => ({
                  ...prev,
                  stage1: false,
                  stage1IsLoading: false,
                }));
                setIsProgress(false);
            }
          }

          setImportedFile(null);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log({ err });
        });
    }

    return () => {
      clearTimeout();
    };
  }, [importedFile]);

  const AddMainCensus = (file) => {
    AddMainCensusFromImportCensus(client?.clientID, 0, 0, user.UD_id).then(
      (res) => {
        if (res.data === "success") {
          UpdatePlanDeviation(file);
        } else {
          toastFile("Something Went wrong please try again");
          setTimeout(() => {
            setIsProgress(false);
          }, 2000);
        }
      }
    );
  };

  const UpdatePlanDeviation = (file) => {
    let client_name = client?.clientName.replaceAll("&", "%26").replaceAll("#", "%23")
    DeletePlanDeviationByClientId(
      client?.clientID,
      0,
      0,
      client_name
    ).then((res) => {
      if (res.data === "success") {
        setLoadingStage((prev) => ({
          ...prev,
          stage1IsLoading: false,
          stage2: true,
          stage2IsLoading: true,
        }));
        setTimeout(() => {
          setLoadingStage((prev) => ({
            ...prev,
            stage2IsLoading: false,
            stage3: true,
            stage3IsLoading: true,
          }));
        }, 1000);
        setTimeout(() => {
          setLoadingStage((prev) => ({
            ...prev,
            stage3IsLoading: false,
          }));
          setIsLoading(false);
          if (file === "") {
            // const toastmessage = (
            //   <div>
            //     <span>
            //       Census for Client <b> {client?.clientName} </b> was
            //       successfully imported. Please go to the Client Data section
            //       and update the following data elements. Once updated, please
            //       complete the process by clicking the Recalibrate Census Data button from this page or the Plan AV & Deviation page
            //     </span>{" "}
            //     <br />
            //     <br />
            //     <span>1. Wellness Programs</span>
            //     <br />
            //     <span> 2. Cobra Participation</span>
            //     <br />
            //     <span>3. Plan AV & Deviation</span>
            //   </div>
            // );
           // toastFile(toastmessage, "success");
            setTimeout(() => {
             // setIsProgress(false);
              RecalibrateCensus()
            }, 2000);
          } else {
            setPartialModal((prev) => ({
              isModal: true,
              file: file,
            }));
          }
        }, 2000);
      //  setIsLink(true);
      } else {
        toastFile("Something Went wrong please try again");
      }
    });
  };

  const DeleteExstingCarrier = (file) => {
    DeleteClientLargeClaimUWByClientId(client.clientID, user.UD_id).then(
      (res) => {
        // console.log({ res });
        if (res.data === "success") {
          AddMainCensus(file);
        } else {
          toastFile("Something Went wrong please try again");
        }
        setShowCarrierDeleteModel({
          isModel: false,
          file: "",
        });
      }
    );
  };

  const updateCensusStageApiCall = async (stage, apiname) => {
    setLoadingStage((prev) => ({
      ...prev,
      [`stage${stage}`]: true,
      [`stage${stage}IsLoading`]: true,
    }));
    await apiname().then((res) => {
      if (res.status === 200) {
        setLoadingStage((prev) => ({
          ...prev,
          [`stage${stage}IsLoading`]: false,
        }));
        stage === 6 && toastFile("update");
      }
    });
  };

  const liClassName =
    "list-group-item d-flex justify-content-start align-items-center gap-3 px-3 border-0";
    
  const overrideColumn = [
      { title: "Gender", field: "gender" },
      { title: "DOB", field: "dob" ,
      render: (rowData) => moment(rowData.dob).format("MM-DD-yyyy"),
      },
      { title: "Zip Code", field: "zipCode" },
      { title: "Carrier", field: "carrier" },
      { title: "Plan Name", field: "plan_name" },
      { title: "Plan Type", field: "plan_type" },
      { title: "Relationship", field: "relationship" },
      { title: "Tier", field: "tier" },
      { title: "Current Rate", field: "currentRate" },
      { title: "Salary", field: "salary" },
      { title: "Imported By", field: "imported_by" },
      { title: "Imported Date", field: "import_date", render: (rowData) => moment(rowData.import_date).format("MM-DD-yyyy"), },
    ];
useEffect(() => {
  if(showTable){
    setShowTable(false)
     setTimeout(() => {
       setShowTable(true)
     }, 200);
  }
}, [client])

  const getCensusData = (query) =>{
    return new Promise((resolve, reject) => {
      GetCensusDataByClientIdwithPagging(
          client?.clientID,
          +query.page + 1,
          query.pageSize,
        ).then((result) => {
          resolve({
            data: result.data.censusDetails,
            page: query.page,
            totalCount: result.data.totalPages * query.pageSize,
          });
          setIsLoading(false)
        }).catch((error) => {
          reject(error);
          setIsLoading(false)
        });
     
      })
  }

const RecalibrateCensus = async() => {
    if (
      client === null ||
      client?.clientID === null ||
      client?.clientID === 0
    ) {
      toastFile("Select Client");
    } else {
      setLoadingStage({
        stage1: true,
        stage1IsLoading: false,
        stage2: false,
        stage2IsLoading: false,
        stage3: false,
        stage3IsLoading: false,
        stage4: false,
        stage4IsLoading: false,
        stage5: false,
        stage5IsLoading: false,
        stage6: false,
        stage6IsLoading: false,
      });
      setWitchAction("Updating");
      setIsProgress(true);
      setIsLoading(true);
      const checkClient = await CheckClientInCensusByClientId(
        client?.clientID
      );
      if (checkClient.data === "plan not found") {
        setWitchAction("");
        setIsProgress(false);
        toastFile(checkClient.data);
      } else if (checkClient.data === "client not found") {
        setIsProgress(false);
        toastFile("Please import Cencus first and try again.", "error");
      } else {
        setLoadingStage((prev) => ({
          ...prev,
          stage1: true,
          stage1IsLoading: true,
        }));
        UpdateCensus(client?.clientID, 1, user.UD_id).then((res) => {
          if (res.data === "stage1") {
            setLoadingStage((prev) => ({
              ...prev,
              stage2: true,
              stage1IsLoading: false,
              stage2IsLoading: true,
            }));
            UpdateCensusStage2(client?.clientID, 2, user.UD_id).then(
              (res) => {
                if (res.data === "stage2") {
                  setLoadingStage((prev) => ({
                    ...prev,
                    stage3: true,
                    stage2IsLoading: false,
                    stage3IsLoading: true,
                  }));
                  UpdateCensusStage3(
                    client?.clientID,
                    3,
                    user.UD_id
                  ).then((res) => {
                    if (res.data === "stage3") {
                      setLoadingStage((prev) => ({
                        ...prev,
                        stage4: true,
                        stage3IsLoading: false,
                        stage4IsLoading: true,
                      }));
                      UpdateCensusStage4(
                        client?.clientID,
                        4,
                        user.UD_id
                      ).then((res) => {
                        if (res.data === "stage4") {
                          setLoadingStage((prev) => ({
                            ...prev,
                            stage5: true,
                            stage4IsLoading: false,
                            stage5IsLoading: true,
                          }));
                          UpdateCensusStage5(
                            client?.clientID,
                            5,
                            user.UD_id
                          ).then((res) => {
                            if (res.data === "stage5") {
                              setLoadingStage((prev) => ({
                                ...prev,
                                stage6: true,
                                stage5IsLoading: false,
                                stage6IsLoading: true,
                              }));
                              UpdateCensusStage6(
                                client?.clientID,
                                6,
                                user.UD_id
                              ).then((res) => {
                                if (res.data === "stage6") {
                                  setLoadingStage((prev) => ({
                                    ...prev,
                                    stage6IsLoading: false,
                                  }));
                                  toastFile("imported");
                                  setIsLoading(false);
                                  setTimeout(() => {
                                    setIsProgress(false);
                                  }, 2000);
                                } else {
                                  setIsLoading(false);
                                  setLoadingStage((prev) => ({
                                    ...prev,
                                    stage6IsLoading: false,
                                  }));
                                  toastFile("Something went wrong.");
                                  setTimeout(() => {
                                    setIsProgress(false);
                                  }, 2000);
                                }
                              });
                            } else {
                              setIsLoading(false);
                              setLoadingStage((prev) => ({
                                ...prev,
                                stage5IsLoading: false,
                              }));
                              toastFile("Something went wrong.");
                              setTimeout(() => {
                                setIsProgress(false);
                              }, 2000);
                            }
                          });
                        } else {
                          setIsLoading(false);
                          setLoadingStage((prev) => ({
                            ...prev,
                            stage4IsLoading: false,
                          }));
                          toastFile("Something went wrong.");
                          setTimeout(() => {
                            setIsProgress(false);
                          }, 2000);
                        }
                      });
                    } else {
                      setIsLoading(false);
                      setLoadingStage((prev) => ({
                        ...prev,
                        stage3IsLoading: false,
                      }));
                      toastFile("Something went wrong.");
                      setTimeout(() => {
                        setIsProgress(false);
                      }, 2000);
                    }
                  });
                } else {
                  setIsLoading(false);
                  setLoadingStage((prev) => ({
                    ...prev,
                    stage2IsLoading: false,
                  }));
                  toastFile("Something went wrong.");
                  setTimeout(() => {
                    setIsProgress(false);
                  }, 2000);
                }
              }
            );
          } else {
            setIsLoading(false);
            setLoadingStage((prev) => ({
              ...prev,
              stage1IsLoading: false,
            }));
            toastFile("Something went wrong.");
            setTimeout(() => {
              setIsProgress(false);
            }, 2000);
          }
        });
        
      }
    }
}
  

  return (
    <div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Have you prepared the import file using the CSV format?
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={Fontstyling.savebutton}
            onClick={() => {
              fileInputRef.current.click();
              setShowModal(false);
            }}
          >
            Yes
          </Button>
          <Button
            style={Fontstyling.cancelbutton}
            onClick={() => {
              setShowModal(false);
            }}
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showCarrierDeleteModel.isModel}
        onHide={() => {
          setShowCarrierDeleteModel({
            isModel: false,
            file: "",
          });
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          The carrier in the census file does not match the carrier in the
          client Large Claim Underwriting Summary. Do you want to proceed?
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={Fontstyling.savebutton}
            onClick={() => {
              DeleteExstingCarrier(showCarrierDeleteModel.file);
            }}
          >
            Delete Exisiting Carrier
          </Button>
          <Button
            style={Fontstyling.cancelbutton}
            onClick={() => {
              setShowCarrierDeleteModel({
                isModel: false,
                file: "",
              });
              setLoadingStage((prev) => ({
                ...prev,
                stage1: false,
              }));
              setIsProgress(false);
            }}
          >
            No changes
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={message.isModal}
        onHide={() => setMessage((prev) => ({ ...prev, isModal: false }))}
      >
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          There are blank or invalid values in your import file. Please click
          Download Error Log , correct the import file accordingly, and then try
          again.
        </Modal.Body>
        <Modal.Footer>
          <div>
            <Button
              className="bg-transparent border-0 text-primary"
              onClick={() => {
                DownloadCensusErrorFile(message.file).then((data) => {
                  const blob = new Blob([data.data], {
                    type: "text/plain",
                  });
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = message.file;
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                  URL.revokeObjectURL(url);
                  setMessage((prev) => ({ isModal: false, file: "" }));
                });
              }}
            >
              Download Error Log
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal
        show={partialModal.isModal}
        onHide={() => setPartialModal((prev) => ({ ...prev, isModal: false }))}
      >
        <Modal.Header closeButton>
          <Modal.Title>Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <span>
              Census for Client <b> {client?.clientName}</b> was not successfully imported. 
              There are records that cannot be imported due to invalid Zip Code(s), Tier(s), Plan Type(s), or Relationship(s). 
              Please download and review the Error Log, correct the issue(s), and import the updated Census file.
            </span>
            <br />
            {/* <br />
            <span>1. Wellness Programs</span>
            <br />
            <span> 2. Cobra Participation</span>
            <br />
            <br />
            <span>
              There are records that cannot be imported due to invalid
              ZipCode(s). The records will be reviewed by an administrator, once
              reviewed you will be contacted with next steps.
            </span> */}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <Button
              className="bg-transparent border-0 text-primary"
              onClick={() => {
                DownloadCensusErrorFile(partialModal.file).then((data) => {
                  const blob = new Blob([data.data], {
                    type: "text/plain",
                  });
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = partialModal.file;
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                  URL.revokeObjectURL(url);
                  setPartialModal((prev) => ({ isModal: false, file: "" }));
                });
              }}
            >
              Download Error Log
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <div className="d-flex align-items-center justify-content-end py-3 border-bottom gap-3">
        <a
          href="/samplefile/Census_Import_Template.csv"
          target={"_blank"}
          style={{
            textDecoration: "none",
          }}
          onMouseOver={(e) => {
            e.target.style.textDecoration = "underline";
          }}
          onMouseOut={(e) => {
            e.target.style.textDecoration = "none";
          }}
          download
        >
          Download Import Template
        </a>
        <CustomButton
          className={"py-1 px-3 text-wrap"}
          style={{
            ...Fontstyling.addnewbutton,
          }}
          onClick={() => {
            if (
              client === null ||
              client?.clientID === null ||
              client?.clientID === 0
            ) {
              toastFile("Select Client");
            } else {
              setShowModal(true);
            }
          }}
        >
          Import Census
        </CustomButton>
        {/* <CustomButton
          className={"py-1 px-3 text-wrap"}
          style={{
            ...Fontstyling.addnewbutton,
            background: theme.SECONDARY_CHEERFUL_GOLD,
          }}
          onClick={RecalibrateCensus}
        >
          Recalibrate Census Data
        </CustomButton> */}
        <input
          type="file"
          ref={fileInputRef}
          onChange={(event) => {
            setImportedFile(event.target.files[0]);
            event.target.value = "";
          }}
          style={{ display: "none" }}
        />
      </div>
      {/* {isLink && (
        <div className="text-start py-2">
          <Link
            to={"/ACGHealthInsights/clientdata/planavdeviation"}
            style={{
              textDecoration: "none",
            }}
            onMouseOver={(e) => {
              e.target.style.textDecoration = "underline";
            }}
            onMouseOut={(e) => {
              e.target.style.textDecoration = "none";
            }}
          >
            Click here to go to the Plan AV & Deviation page
          </Link>
        </div>
      )} */}

      {isProgress && (
        <div className="border bg-white">
          <div
            className="d-flex align-items-center justify-content-between px-3 py-1 mb-2"
            style={{
              backgroundColor: theme.SECONDARY_SHOCKING_BLUE,
              color: theme.PRIMARY_PURE_WHITE,
            }}
          >
            <div>Data Import Progress</div>
            {isLoading ? (
              <div className="">{witchAction} Census data..</div>
            ) : (
              <div id="imComplate" className="">
                {witchAction === "Importing" ? "Import" : "Update"} data
                successful
              </div>
            )}
          </div>
          <ul
            className="list-group border-0 mb-3"
            style={{ listStyle: "none" }}
          >
            {witchAction === "Importing" ? (
              <>
                {loadingSatge.stage1 && (
                  <>
                    {loadingSatge.stage1IsLoading ? (
                      <li className={liClassName}>
                        <span>
                          <img
                            src={require("../../../../assets/gif/list-icon-gif.gif")}
                          />
                        </span>
                        <span>
                          Preparing Census ACG<sup>©</sup> National Database
                        </span>
                      </li>
                    ) : (
                      <li className={liClassName}>
                        <span>
                          <img
                            src={require("../../../../assets/import-census-img.png")}
                          />
                        </span>
                        <span>
                          Preparing Census ACG<sup>©</sup> National Database
                        </span>
                      </li>
                    )}
                  </>
                )}
                {loadingSatge.stage2 && (
                  <>
                    {loadingSatge.stage2IsLoading ? (
                      <li className={liClassName}>
                        <span>
                          <img
                            src={require("../../../../assets/gif/list-icon-gif.gif")}
                          />
                        </span>
                        <span>
                          Uploading Census ACG<sup>©</sup> National Database
                        </span>
                      </li>
                    ) : (
                      <li className={liClassName}>
                        <span>
                          <img
                            src={require("../../../../assets/import-census-img.png")}
                          />
                        </span>
                        <span>
                          Uploading Census ACG<sup>©</sup> National Database
                        </span>
                      </li>
                    )}
                  </>
                )}
                {loadingSatge.stage3 && (
                  <>
                    {loadingSatge.stage3IsLoading ? (
                      <li className={liClassName}>
                        <span>
                          <img
                            src={require("../../../../assets/gif/list-icon-gif.gif")}
                          />
                        </span>
                        Updating/Populating Client Data
                      </li>
                    ) : (
                      <li className={liClassName}>
                        <span>
                          <img
                            src={require("../../../../assets/import-census-img.png")}
                          />
                        </span>
                        Updating/Populating Client Data
                      </li>
                    )}
                  </>
                )}
                {/* <li id="listep1" className={liClassName}>
                  <span>
                    <img
                      id="imgstep1"
                      src={require("../../../../assets/import-census-img.png")}
                    />
                  </span>
                  <div>
                    Preparing Census ACG<sup>©</sup> National Database
                  </div>
                </li>
                <li id="listep2" className={liClassName}>
                  <span>
                    <img
                      id="imgstep2"
                      src={require("../../../../assets/import-census-img.png")}
                    />
                  </span>
                  <div>
                    Uploading Census ACG<sup>©</sup> National Database
                  </div>
                </li>
                <li id="listep3" className={liClassName}>
                  <span>
                    <img
                      id="imgstep3"
                      src={require("../../../../assets/import-census-img.png")}
                    />
                  </span>
                  <div>Updating/Populating Client Data</div>
                </li> */}
              </>
            ) : (
              <>
                {loadingSatge.stage1 && (
                  <>
                    {loadingSatge.stage1IsLoading ? (
                      <li className={liClassName}>
                        <span>
                          <img
                            src={require("../../../../assets/gif/list-icon-gif.gif")}
                          />
                        </span>
                        Validating information
                      </li>
                    ) : (
                      <li className={liClassName}>
                        <span>
                          <img
                            src={require("../../../../assets/import-census-img.png")}
                          />
                        </span>
                        Validating information
                      </li>
                    )}
                  </>
                )}
                {loadingSatge.stage2 && (
                  <>
                    {loadingSatge.stage2IsLoading ? (
                      <li className={liClassName}>
                        <span>
                          <img
                            src={require("../../../../assets/gif/list-icon-gif.gif")}
                          />
                        </span>
                        Applying Risk Score, Lifestyle Factors
                      </li>
                    ) : (
                      <li className={liClassName}>
                        <span>
                          <img
                            src={require("../../../../assets/import-census-img.png")}
                          />
                        </span>
                        Applying Risk Score, Lifestyle Factors
                      </li>
                    )}
                  </>
                )}
                {loadingSatge.stage3 && (
                  <>
                    {loadingSatge.stage3IsLoading ? (
                      <li className={liClassName}>
                        <span>
                          <img
                            src={require("../../../../assets/gif/list-icon-gif.gif")}
                          />
                        </span>
                        Finalizing Client Output and Assessment
                      </li>
                    ) : (
                      <li className={liClassName}>
                        <span>
                          <img
                            src={require("../../../../assets/import-census-img.png")}
                          />
                        </span>
                        Finalizing Client Output and Assessment
                      </li>
                    )}
                  </>
                )}
                {loadingSatge.stage4 && (
                  <>
                    {loadingSatge.stage4IsLoading ? (
                      <li className={liClassName}>
                        <span>
                          <img
                            src={require("../../../../assets/gif/list-icon-gif.gif")}
                          />
                        </span>
                        Unpacking Client Output for Extract
                      </li>
                    ) : (
                      <li className={liClassName}>
                        <span>
                          <img
                            src={require("../../../../assets/import-census-img.png")}
                          />
                        </span>
                        Unpacking Client Output for Extract
                      </li>
                    )}
                  </>
                )}
                {loadingSatge.stage5 && (
                  <>
                    {loadingSatge.stage5IsLoading ? (
                      <li className={liClassName}>
                        <span>
                          <img
                            src={require("../../../../assets/gif/list-icon-gif.gif")}
                          />
                        </span>
                        Closing ACG National Database
                      </li>
                    ) : (
                      <li className={liClassName}>
                        <span>
                          <img
                            src={require("../../../../assets/import-census-img.png")}
                          />
                        </span>
                        Closing ACG National Database
                      </li>
                    )}
                  </>
                )}
                {loadingSatge.stage6 && (
                  <>
                    {loadingSatge.stage6IsLoading ? (
                      <li className={liClassName}>
                        <span>
                          <img
                            src={require("../../../../assets/gif/list-icon-gif.gif")}
                          />
                        </span>
                        Populating client RUBs
                      </li>
                    ) : (
                      <li className={liClassName}>
                        <span>
                          <img
                            src={require("../../../../assets/import-census-img.png")}
                          />
                        </span>
                        Populating client RUBs
                      </li>
                    )}
                  </>
                )}
                {loadingSatge.stage6 && (
                  <>
                    {loadingSatge.stage6IsLoading ? (
                      <li className={liClassName}>
                        <span>
                          <img
                            src={require("../../../../assets/gif/list-icon-gif.gif")}
                          />
                        </span>
                        Preparing Reporting Data Elements
                      </li>
                    ) : (
                      <li className={liClassName}>
                        <span>
                          <img
                            src={require("../../../../assets/import-census-img.png")}
                          />
                        </span>
                        Preparing Reporting Data Elements
                      </li>
                    )}
                  </>
                )}
                {loadingSatge.stage6 && (
                  <>
                    {loadingSatge.stage6IsLoading ? (
                      <li className={liClassName}>
                        <span>
                          <img
                            src={require("../../../../assets/gif/list-icon-gif.gif")}
                          />
                        </span>
                        Process complete.
                      </li>
                    ) : (
                      <li className={liClassName}>
                        <span>
                          <img
                            src={require("../../../../assets/import-census-img.png")}
                          />
                        </span>
                        Process complete.
                      </li>
                    )}
                  </>
                )}
              </>
            )}
          </ul>
        </div>
      )}
      {!isProgress && client && showTable &&<CustomMaterialTable
      isSearchRequired={'No'}
        isExport={false}
        overrideColumn={overrideColumn}
        data={(query) =>
          getCensusData(query)
        }
        isLoading={isLoadingTable}
        setSelectedRow={setSelectedRow}
      />}
    </div>
  );
};

export default ImportCensus;
